export class ActionApprovalRuleGroupCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "LogicalOperator",
            "format": ""
        },
        {
            "name": "operands",
            "baseName": "operands",
            "type": "Array<ActionApprovalRuleExpression>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActionApprovalRuleGroupCondition.attributeTypeMap;
    }
    constructor() {
    }
}
